import { render, staticRenderFns } from "./DeleteBrigadeRoute.vue?vue&type=template&id=4cc592e7&scoped=true&"
import script from "./DeleteBrigadeRoute.vue?vue&type=script&lang=js&"
export * from "./DeleteBrigadeRoute.vue?vue&type=script&lang=js&"
import style0 from "./DeleteBrigadeRoute.vue?vue&type=style&index=0&id=4cc592e7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc592e7",
  null
  
)

export default component.exports